import { useActionNotifications } from '@/hooks/use-action-notifications';

/**
 * Component that listens for action queue updates and shows notifications
 * This is a "headless" component that doesn't render anything visible
 */
export function ActionNotificationListener() {
  // This hook sets up the listeners for action queue updates
  useActionNotifications();
  
  // This component doesn't render anything
  return null;
}
